import styles from './Card.module.scss';

import { Icon, IIconProps, ImageType } from '../icon/Icon';

export interface ICardProps {
    icons: number[];
    images: ImageType[];
    sharedNumber: number;
    onClickSharedNumber: () => void;
    onClickWrongIcon?: () => void;
    // Clicking disabled as a penalty for selecting the wrong buddy
    isDisabled: boolean;
    // If the card is in the player's hand
    isPlayerCard?: boolean;
    children?: React.ReactNode;
    isNextCard?: boolean;
}

export function Card(props: ICardProps) {
    const { 
        icons, 
        images, 
        sharedNumber, 
        onClickSharedNumber, 
        onClickWrongIcon,
        isDisabled,
        isPlayerCard,
        children,
        isNextCard
    } = props;

    let iconProps: IIconProps[] = [];
    for (let icon of icons) {
        iconProps.push({
            iconIndex: icon,
            image: images[icon],
            onClickSharedNumber: 
                isDisabled ? () => {} :
                (
                    icon === sharedNumber ? 
                    onClickSharedNumber : 
                    onClickWrongIcon
                ),
            isDisabled: isDisabled
        })
    }

    const cardClassName: string = isPlayerCard ? 
        styles.cardRoot + ' ' + styles.playerCardRoot : isNextCard ?
        styles.cardRoot + ' ' + styles.nextCard :
        styles.cardRoot;

    return (
        <div className={styles.cardsRoot} id={isPlayerCard ? 'playerCardsRoot' : 'cardsRoot'}>
            <div className={cardClassName} id={isPlayerCard ? 'playerCard' : 'deckCard'}>
                <div className={styles.row}>
                    <Icon {...iconProps[0]} />
                    <Icon {...iconProps[1]} />
                </div>
                <div className={styles.row}>
                    <Icon {...iconProps[2]} />
                    <Icon {...iconProps[3]} />
                    <Icon {...iconProps[7]} />
                </div>
                <div className={styles.row}>
                    <Icon {...iconProps[4]} />
                    <Icon {...iconProps[5]} />
                    <Icon {...iconProps[6]} />
                </div>
            </div>
            <div className={styles.cardBack} id='cardBack'>
                {children}
            </div>
        </div>
    );
}

interface IEmptyCardProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
}

export const EmptyCard = (props: IEmptyCardProps) => {
    const cardClassName: string = styles.cardRoot + ' ' + styles.emptyCardRoot + ' ' + styles.className;

    return <div className={cardClassName} id={'emptyCard'} />
}